var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { staticClass: "root" },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.title) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("w-input", {
            ref: "barcode",
            staticClass: "barcode",
            attrs: { autofocus: true, placeholder: _vm.$ct("barcode") },
            on: {
              keypress: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.fetch.apply(null, arguments)
              },
              focus: _vm.clearOnFocus,
            },
            model: {
              value: _vm.text,
              callback: function ($$v) {
                _vm.text = $$v
              },
              expression: "text",
            },
          }),
        ],
        1
      ),
      _vm.product
        ? _c("div", { staticClass: "product" }, [
            _vm._v(
              " " +
                _vm._s(_vm.product.Name) +
                " | " +
                _vm._s(_vm.product.Sku) +
                " "
            ),
          ])
        : _vm._e(),
      _c("div", { staticClass: "stock-wrap" }, [
        _vm.product
          ? _c(
              "div",
              { staticClass: "total-stock" },
              [
                _c(
                  "div",
                  {
                    staticClass: "btt",
                    on: {
                      click: function ($event) {
                        _vm.toggleStockDetail = !_vm.toggleStockDetail
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$ct("total-stock")) +
                        " " +
                        _vm._s(_vm.totalStock) +
                        " "
                    ),
                    _c("w-fa", {
                      staticClass: "mls",
                      attrs: {
                        icon: _vm.toggleStockDetail
                          ? "chevron-down"
                          : "chevron-up",
                      },
                    }),
                  ],
                  1
                ),
                _c("w-spacer"),
                _c(
                  "div",
                  {
                    staticClass: "btt",
                    on: {
                      click: function ($event) {
                        _vm.togglePrices = !_vm.togglePrices
                      },
                    },
                  },
                  [
                    _vm._v(" € " + _vm._s(_vm.product["SellPrice1"]) + " "),
                    _c("w-fa", {
                      staticClass: "mls",
                      attrs: {
                        icon: _vm.togglePrices ? "chevron-down" : "chevron-up",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.toggleStockDetail
          ? _c(
              "div",
              { staticClass: "stock-locations" },
              _vm._l(_vm.actualStock, function (stock, i) {
                return _c(
                  "div",
                  { key: i, staticClass: "location" },
                  [
                    _c(
                      "w-row",
                      { style: { display: "flex" } },
                      [
                        _c("w-col", { attrs: { xs: "8" } }, [
                          _vm._v(" " + _vm._s(stock.text) + " "),
                        ]),
                        _c("w-col", { attrs: { xs: "4" } }, [
                          _vm._v(" " + _vm._s(stock.stock) + " "),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e(),
        _vm.product && _vm.togglePrices
          ? _c(
              "div",
              { staticClass: "stock-locations" },
              _vm._l(_vm.visiblePrices, function (category, i) {
                return _c(
                  "div",
                  { key: i, staticClass: "location" },
                  [
                    _c(
                      "w-row",
                      { style: { display: "flex" } },
                      [
                        _c("w-col", { attrs: { xs: "8" } }, [
                          _vm._v(" " + _vm._s(category.categoryName) + " "),
                        ]),
                        _c("w-col", { attrs: { xs: "4" } }, [
                          _vm._v(
                            " € " +
                              _vm._s(
                                _vm.product[
                                  "SellPrice" + category.category + "WithVat"
                                ]
                              ) +
                              " "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e(),
      ]),
      _vm.product
        ? _c(
            "div",
            { staticClass: "actions" },
            [
              _c(
                "w-row",
                { style: { display: "flex" } },
                [
                  _c(
                    "w-col",
                    { style: { paddingLeft: 0 }, attrs: { sm: "12" } },
                    [
                      _c("w-select", {
                        staticClass: "h50",
                        attrs: { value: _vm.type, items: _vm.items },
                        on: {
                          input: function ($event) {
                            return _vm.setType($event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { attrs: { xs: "6", "no-margin": "" } },
                    [
                      _c("w-input-number", {
                        ref: "qty",
                        attrs: { step: 0.01, "force-number": true },
                        model: {
                          value: _vm.qty,
                          callback: function ($$v) {
                            _vm.qty = $$v
                          },
                          expression: "qty",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "w-col",
                    { style: { display: "flex" }, attrs: { xs: "6" } },
                    [
                      _c(
                        "w-button",
                        {
                          style: { flexGrow: "1" },
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.save")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }